import { Bell, LogOut, Moon, Sun } from 'lucide-react';
import { Link, useRouter } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/hooks/useTheme';
import { useAuth } from '@/hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { cn } from '@/lib/utils';

export function Header({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const { user, logout } = useAuth();
  const router = useRouter();
  const { data: alerts } = useQuery({
    queryKey: ['alerts', { unread: true }],
    queryFn: () => api.listAlerts(true),
    refetchInterval: 30_000,
  });
  const unread = alerts?.length ?? 0;

  return (
    <header className={cn('flex h-full items-center justify-between bg-card px-4 sm:px-6', className)}>
      <div className="text-sm text-muted-foreground">{user.email}</div>
      <div className="flex items-center gap-2">
        <Link to="/alerts" className="relative">
          <Button variant="ghost" size="icon" aria-label="Alertes">
            <Bell className="h-4 w-4" />
            {unread > 0 ? (
              <span className="absolute -right-1 -top-1 grid h-4 min-w-4 place-items-center rounded-full bg-destructive px-1 text-[10px] font-bold text-destructive-foreground">
                {unread}
              </span>
            ) : null}
          </Button>
        </Link>
        <Button variant="ghost" size="icon" onClick={toggle} aria-label="Thème">
          {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={async () => {
            await logout.mutateAsync();
            void router.navigate({ to: '/login' });
          }}
          aria-label="Déconnexion"
        >
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
